
<iframe id="iframe_{{candidateVM.symlink}}" [src]="iframeSrcUrl"
        style="width:1285px; height: 805px; overflow: hidden;display: block;"></iframe>
